import React, { FC } from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';
import en_US from 'antd/lib/locale/en_US';
import kk_KZ from 'antd/lib/locale/kk_KZ';
import ru_RU from 'antd/lib/locale/ru_RU';
import 'dayjs/locale/ru';
import 'dayjs/locale/kk';
import AxiosInterceptor from '../../iterceptors/axios.interceptor';


interface TProps {
    language: string;
    tokenTheme?: string;
    children: React.ReactNode;
    translations?: Record<string, string>;
    isError?: boolean;
    token?: string;
    commonTranslations?: Record<string, string>;
    hideNoDataNotification?: boolean;
    disableError?: boolean;
}

if (typeof globalThis.SVGElement === 'undefined') {
    (globalThis.SVGElement as any) = class SVGElement {};
}

const getLocale = (locale: string) => {
    switch (locale) {
        case 'kk_KZ':
            return kk_KZ;
        case 'ru':
            return ru_RU;
        case 'en_150':
            return kk_KZ; //тут надо самим язык добавить в антд чтоле?)  https://ant.design/docs/react/i18n#adding-new-language
        case 'en_US':
            return en_US;
    }
};

const PartWrapper: FC<TProps> = ({
    language = 'ru',
    tokenTheme = 'default',
    children,
    translations = {},
    isError = true,
    token,
    hideNoDataNotification = false,
    disableError = false,
    designProps,
}) => {
    let dp = null;

    if (designProps) {
        dp = designProps;

        if (typeof  window.localStorage !== 'undefined') {
            localStorage.setItem('designProps', JSON.stringify(designProps));
        }
    } else if (typeof  window.localStorage !== 'undefined') {
        dp = JSON.parse(window.localStorage.getItem('designProps'));
    }

    const defaultTheme: ThemeConfig = {
        token: {
            fontFamily: 'Roboto, sans-serif',
            fontSize: dp ? dp.fontSize || 14 : 14
        },
        components: {
            Result: {
                iconFontSize: 48,
                extraMargin: '24px 0 0 0',
            },
        },
        'css-in-js': false
    };

    return (
        <AxiosInterceptor
            translations={translations}
            isError={isError}
            token={token}
            hideNoDataNotification={hideNoDataNotification}
            disableError={disableError}
            language={language}
        >
            <ConfigProvider
                locale={getLocale(language)}
                theme={defaultTheme}
            >
                {children}
            </ConfigProvider>
        </AxiosInterceptor>
    );
};

export default PartWrapper;
